import styled from '@emotion/styled';
import { Box, Column } from '~Styles';
import bLogoBlack from '~Assets/Logos/b_logo_black.svg';

export const Wrapper = styled(Column)`
  overflow-y: scroll;
  height: calc(100vh - 64px);
  position: relative;

  // Psuedo element with background
  ::before {
    background-repeat: space;
    background-position: center;
    background-size: 5%;
    background-image: url(${bLogoBlack});
    opacity: 0.0125;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;

export const SearchWrapper = styled.div`
  padding-left: 32px;
  width: 320px;
  color: #333;
`;

export const SearchHeading = styled.h2`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-style: italic;
`;

export const SearchParagraph = styled.p`
  font-style: italic;
  margin: 0;
  font-size: 12px;
  padding-bottom: 8px;
`;

export const ActionsWrapper = styled(Box)`
  border-radius: 4px;
  margin: 0 auto;
  width: 640px;
  background: #fff;
  padding: 48px;
`;

export const ActionsHeading = styled.h2`
  margin: 0 0 24px;
  font-weight: normal;
`;

export const ActionsHeadingBold = styled.span`
  font-weight: bold;
`;

export const InfoHeading = styled.h3`
  margin: 0;
  font-weight: normal;
`;

export const InfoParagraph = styled.p`
  margin: 8px 0 32px;
  color: #333;
`;
